// Reusable numeric input with increment/decrement buttons.
// MUI-based refactor: sx styling, theme tokens, and useBreakpoint contract.
import { Box, TextField, IconButton, Typography } from '@mui/material';
import { useBreakpoint } from '@/hooks/ui/useBreakpoint.js';
import { fieldLabelSx } from '@/features/tasks/components/forms/taskFormStyles';

const SMALL_SCREEN_OPACITY_DISABLED = 0.5;

const TimeInputControl = ({
  label,
  id,
  value,
  onChange,
  onIncrement,
  onDecrement,
  onBlur,
  disabled,
  title,
}) => {
  const currentBreakpoint = useBreakpoint();
  // Enum contract: xs/s/m/l/xl. Small-screen layout for xs and s.
  const isSmallScreen = currentBreakpoint === 'xs' || currentBreakpoint === 's';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        opacity: disabled ? SMALL_SCREEN_OPACITY_DISABLED : 1,
      }}
      title={title}
    >
      <Typography component="label" htmlFor={id} sx={fieldLabelSx}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {isSmallScreen ? (
          <IconButton
            size="small"
            onClick={onDecrement}
            disabled={disabled}
            sx={{ p: 0.5, width: 32, height: 32 }}
          >
            −
          </IconButton>
        ) : null}
        <TextField
          id={id}
          type="text"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          size="small"
          fullWidth
          InputProps={{ readOnly: disabled }}
          sx={{ textAlign: 'center' }}
        />
        {isSmallScreen ? (
          <IconButton
            size="small"
            onClick={onIncrement}
            disabled={disabled}
            sx={{ p: 0.5, width: 32, height: 32 }}
          >
            +
          </IconButton>
        ) : null}
      </Box>
    </Box>
  );
};

export default TimeInputControl;
